import { createRoot } from "react-dom/client";
import "../../css/PrepayConfirmModal.css";

// Uso: const ok = await spConfirm("Mensaje");
export default function spConfirm(message, title = "Confirmar") {
    return new Promise((resolve) => {
        const el = document.createElement("div");
        document.body.appendChild(el);
        const root = createRoot(el);

        const close = (result) => {
            root.unmount();
            el.remove();
            resolve(result);
        };

        root.render(
            <div className="sp-pcm-overlay" onMouseDown={() => close(false)}>
                <div className="sp-pcm-modal" onMouseDown={(e) => e.stopPropagation()}>
                    <header className="sp-pcm-header">
                        <h2 className="sp-pcm-title">{title}</h2>
                    </header>
                    <div className="sp-pcm-body">
                        <p className="sp-pcm-text">{message}</p>
                    </div>
                    <footer className="sp-pcm-footer">
                        <button className="sp-pcm-btn sp-pcm-btn--ghost" onClick={() => close(false)}>
                            Cancelar
                        </button>
                        <button autoFocus className="sp-pcm-btn sp-pcm-btn--success" onClick={() => close(true)}>
                            Aceptar y continuar
                        </button>
                    </footer>
                </div>
            </div>
        );
    });
}